// src/project/data/fetches/orders.js
import { buildUrlWithAuth, RIDER_ENDPOINTS } from '../config/apiConfig'
import parseExternalDelivery from '../scripts/parseExternalDelivery'
import Storage from '@/shared/utils/storage'

export default {
  url(payload) {
    console.log('🚀 ~ payload:', payload)
    // Récupérer les commandes non encore assignées à un livreur
    const params = { status: 'accepted,preparing,picked_up,ready_for_pickup,arrived', pendingOrder: 'true' }

    const riderLocation = Storage.get('userData')?.location
    if (riderLocation?.latitude && riderLocation?.longitude) {
      params.lat = riderLocation.latitude
      params.lng = riderLocation.longitude
    }

    return buildUrlWithAuth(RIDER_ENDPOINTS.ORDER_LIST, params)
  },
  parse(raw = {}) {
    // Réponse V3 attendue :
    // { statusCode: 200, message: "Orders found", data: { data: [...], total, page, limit, pages } }
    console.log("🚀 ~ raw:", raw)
    if (raw?.statusCode === 404) {
      return {
        statusCode: 200,
        message: 'Empty',
        data: [],
      }
    }
    if (raw?.statusCode !== 200 && !raw?.data) {
      return {
        statusCode: raw?.statusCode || 500,
        message: raw?.message || 'Échec de connexion au serveur',
        data: null,
      }
    }

    let deliveries = Array.isArray(raw?.data?.data)
      ? raw.data.data
      : Array.isArray(raw?.data?.items)
        ? raw.data.items
        : Array.isArray(raw?.data)
          ? raw.data
          : []
    deliveries = deliveries.filter(el => el.deliveryOption != 'manualTook')
    deliveries = deliveries.filter(
      el =>
        !!el.metadata?.restaurantLocation?.lng &&
        !!el.metadata?.restaurantLocation?.lat,
    )

    return {
      statusCode: 200,
      message: 'Ok',
      data: deliveries.map(d => parseExternalDelivery(d)).filter(Boolean),
    }
  },
}
